export default __webpack_public_path__ + "static/media/gallery-wip-neck_03.c79b1739.jpg";